var rating = function() {
    var i = 1;
    var string = '<div class="col-lg-12 col-md-12">' +
        'Rate Question:' +
        '<ul class="stars">' +
        '<li class="star" data="'+ i++ +'"><span class="glyphicon glyphicon-star"></span></li>' +
        '<li class="star" data="'+ i++ +'"><span class="glyphicon glyphicon-star"></span></li>' +
        '<li class="star" data="'+ i++ +'"><span class="glyphicon glyphicon-star"></span></li>' +
        '<li class="star" data="'+ i++ +'"><span class="glyphicon glyphicon-star"></span></li>' +
        '<li class="star" data="'+ i +'"><span class="glyphicon glyphicon-star"></span></li>' +
        '</ul>' +
        '</div>';

    return $.parseHTML(string);
}


module.exports = rating;




//////////////////
// WEBPACK FOOTER
// ./src/exam_parts/rating.js
// module id = 231
// module chunks = 0